import { useState } from "react";
import { Row, Col, Button, Form } from "react-bootstrap";
import { Select } from "../../../common/select/Select";
import { Input } from "../../../common/input/Input";
import { PaymentMethod } from "../../../../app/constant/PaymentMethod";

export const PaymentDetailsSection = ({
  register,
  errors,
  paymentFields,
  orderType,
}) => {
  const [removingIndex, setRemovingIndex] = useState(null);
  const handleRemove = (index) => {
    setRemovingIndex(index);
    setTimeout(() => {
      paymentFields.remove(index);
      setRemovingIndex(null);
    }, 1000); // match animation duration
  };

  const paymentOptions =
    orderType === "REFUND_DELIVERY" || orderType === "DELIVERY"
      ? [{ value: PaymentMethod.Cash, label: PaymentMethod.Cash }]
      : Object.values(PaymentMethod).map((method) => ({
          value: method,
          label: method,
        }));
  return (
    <div>
      {paymentFields.fields.length > 0 && (
        <h4>
          <span>Payment </span>
          Details
        </h4>
      )}
      {paymentFields.fields.map((item, index) => (
        <Row
          key={item.id}
          className={`align-items-end animate__animated ${
            removingIndex === index ? "animate__hinge" : "animate__flash"
          }`}
        >
          <Col md={5}>
            <Select
              label="Payment Method"
              field={`paymentDetailsRequestDtos.${index}.paymentMethod`}
              register={register}
              errors={errors}
              options={paymentOptions}
            />
          </Col>
          <Col md={5}>
            <Input
              label="Amount Paid"
              field={`paymentDetailsRequestDtos.${index}.amountPaid`}
              register={register}
              errors={errors}
              type="number"
            />
          </Col>
          <Col md={2}>
            <Form.Group className="mb-3">
              <Form.Label>&nbsp;</Form.Label>
              <Button
                variant="outline-danger"
                onClick={() => handleRemove(index)}
                disabled={removingIndex === index}
                className="w-100"
              >
                Remove
              </Button>
            </Form.Group>
          </Col>
        </Row>
      ))}
      <Row>
        <Col md={{ span: 2, offset: 10 }}>
          <Button
            className="w-100"
            variant="outline-warning"
            onClick={() =>
              paymentFields.append({ paymentMethod: "CASH", amountPaid: 0 })
            }
          >
            Add Payment
          </Button>
        </Col>
      </Row>
    </div>
  );
};
